import { MagnifyingGlass } from "@phosphor-icons/react";
import { forwardRef, type InputHTMLAttributes } from "react";

export const MenuSearchInput = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
  <div className="relative flex items-center border-b border-b-black-200">
    <MagnifyingGlass className="pointer-events-none absolute left-3.5 size-5" />
    <input
      placeholder="Search..."
      {...props}
      ref={ref}
      onKeyDown={(e) => {
        e.stopPropagation();
      }}
      className="w-full py-2.5 pl-10 pr-3.5 text-sm-medium placeholder:text-black-500 focus-visible:outline-0"
    />
  </div>
));
MenuSearchInput.displayName = "MenuSearchInput";
